
import { EpimsBaseEntityDto } from './epim-base.dto';
export class GeoDatumDto extends EpimsBaseEntityDto {
 
DatumId: string;
Version: Number;
DatumName: string;

SubscriptionUserId: string;
}
